/**
 * trade
 * 支付API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import OrderResultDto from '../../trade/model/OrderResultDto';
import PagingTradeDto from '../../trade/model/PagingTradeDto';
import UnifiedOrderForm from '../../trade/model/UnifiedOrderForm';
  /**
   * Trade service.
   * @module trade/api/TradeApi
   * @version 0.2.0
   */

  /**
   * Constructs a new TradeApi. 
   * @alias module:trade/api/TradeApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 查询缴费历史
     * @param {Integer} page 当前页
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:trade/model/PagingTradeDto}
     */
    this.findPagingTrade = function(page) {
      var postBody = null;

      // verify the required parameter 'page' is set
      if (page == undefined || page == null) {
        throw "Missing the required parameter 'page' when calling findPagingTrade";
      }


      var pathParams = {
      };
      var queryParams = {
        'page': page
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingTradeDto;

      return this.apiClient.callApi(
        '/api/trade/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, false
      );
    }


    /**
     * 微信回调
     * @param {String} xmlData xmlData
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    this.payCallbackAction = function(xmlData) {
      var postBody = xmlData;

      // verify the required parameter 'xmlData' is set
      if (xmlData == undefined || xmlData == null) {
        throw "Missing the required parameter 'xmlData' when calling payCallbackAction";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/xml'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/api/trade/payCallback', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, false
      );
    }


    /**
     * 微信统一下单接口
     * @param {module:trade/model/UnifiedOrderForm} body 统一下单表单
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:trade/model/OrderResultDto}
     */
    this.unifiedOrder = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling unifiedOrder";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = OrderResultDto;

      return this.apiClient.callApi(
        '/api/trade/unified_order', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, false
      );
    }
  };

  export default exports;
